import { render, staticRenderFns } from "./EstimateTable.vue?vue&type=template&id=12e72de2&scoped=true&"
import script from "./EstimateTable.vue?vue&type=script&lang=js&"
export * from "./EstimateTable.vue?vue&type=script&lang=js&"
import style0 from "./EstimateTable.vue?vue&type=style&index=0&id=12e72de2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e72de2",
  null
  
)

export default component.exports